import { HEADER_MENU_TITLE_LINK } from '../../constants'
import { formatUrl } from '../../helperFunctions'

export const SERVICES = [
  {
    title: HEADER_MENU_TITLE_LINK.services.integration,
    link: `/services/${formatUrl(HEADER_MENU_TITLE_LINK.services.integration)}`
  },

  {
    title: HEADER_MENU_TITLE_LINK.services.design,
    link: `/services/${formatUrl(HEADER_MENU_TITLE_LINK.services.design)}`
  },

  {
    title: HEADER_MENU_TITLE_LINK.services.consultation,
    link: `/services/${formatUrl(HEADER_MENU_TITLE_LINK.services.consultation)}`
  },

  {
    title: HEADER_MENU_TITLE_LINK.services.trainingMaintenance,
    link: `/services/${formatUrl(HEADER_MENU_TITLE_LINK.services.trainingMaintenance)}`
  },

  {
    title: HEADER_MENU_TITLE_LINK.services.avEngineering,
    link: `/services/${formatUrl(HEADER_MENU_TITLE_LINK.services.avEngineering)}`
  },

  {
    title: HEADER_MENU_TITLE_LINK.services.avProgramming,
    link: `/services/${formatUrl(HEADER_MENU_TITLE_LINK.services.avProgramming)}`
  },

  {
    title: HEADER_MENU_TITLE_LINK.services.procurement,
    link: `/services/${formatUrl(HEADER_MENU_TITLE_LINK.services.procurement)}`
  },

  {
    title: HEADER_MENU_TITLE_LINK.services.remoteManagement,
    link: `/services/${formatUrl(HEADER_MENU_TITLE_LINK.services.remoteManagement)}`
  },
]

export const MARKET = [
  {
    title: 'Government',
    link: '/market/government'
  },

  {
    title: 'Education',
    link: '/market/education'
  },

  {
    title: 'House of Worship',
    link: '/market/house-of-worship'
  },

  {
    title: 'Private / Commercial',
    link: '/market/private-commercial'
  },
]

export const COMPANY = [
  {
    title: HEADER_MENU_TITLE_LINK.company.aboutUs,
    link: `/company/${formatUrl(HEADER_MENU_TITLE_LINK.company.aboutUs)}`
  },

  {
    title: HEADER_MENU_TITLE_LINK.company.certifications,
    link: `/company/certifications-licenses`
  },

  {
    title: HEADER_MENU_TITLE_LINK.company.caseStudy,
    link: `/company/${formatUrl(HEADER_MENU_TITLE_LINK.company.caseStudy)}`
  },

  {
    title: HEADER_MENU_TITLE_LINK.company.newsletter,
    link: `/company/${formatUrl(HEADER_MENU_TITLE_LINK.company.newsletter)}`
  },

  {
    title: HEADER_MENU_TITLE_LINK.company.quote,
    link: `/company/${formatUrl(HEADER_MENU_TITLE_LINK.company.quote)}`
  },
]

export const SOLUTIONS = [
  {
    title: HEADER_MENU_TITLE_LINK.solutions.audioVisual,
    link: `/solutions/${formatUrl(HEADER_MENU_TITLE_LINK.solutions.audioVisual)}`
  },

  {
    title: HEADER_MENU_TITLE_LINK.solutions.videoSignage,
    link: `/solutions/${formatUrl(HEADER_MENU_TITLE_LINK.solutions.videoSignage)}`
  },

  {
    title: HEADER_MENU_TITLE_LINK.solutions.unifiedCommunication,
    link: `/solutions/${formatUrl(HEADER_MENU_TITLE_LINK.solutions.unifiedCommunication)}`
  },

  {
    title: HEADER_MENU_TITLE_LINK.solutions.controlSystem,
    link: `/solutions/${formatUrl(HEADER_MENU_TITLE_LINK.solutions.controlSystem)}`
  },

  {
    title: HEADER_MENU_TITLE_LINK.solutions.publicAddress,
    link: `/solutions/${formatUrl(HEADER_MENU_TITLE_LINK.solutions.publicAddress)}`
  },

  {
    title: HEADER_MENU_TITLE_LINK.solutions.theatricalLighting,
    link: `/solutions/${formatUrl(HEADER_MENU_TITLE_LINK.solutions.theatricalLighting)}`
  },

  {
    title: HEADER_MENU_TITLE_LINK.solutions.securitySurveillance,
    link: `/solutions/${formatUrl(HEADER_MENU_TITLE_LINK.solutions.securitySurveillance)}`
  },

  {
    title: HEADER_MENU_TITLE_LINK.solutions.hearingLoop,
    link: `/solutions/${formatUrl(HEADER_MENU_TITLE_LINK.solutions.hearingLoop)}`
  }
]